module.exports = __webpack_public_path__ + "img/simOpen105.dc580a7d.png";